<!-- radio组件 -->
<template>
    <ul class="resume-radio">
        <li v-for="(item, idx) in data" :key="idx" :class="{select: item.id === value}" @click="$emit('input', item.id)">
            {{ item.label }}
        </li>
    </ul>
</template>
<script>
export default {
    // eslint-disable-next-line vue/require-prop-types
    props: ['value', 'data'],
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    methods: {}
};
</script>
